import amazon from './amazon'

export default { amazon };
